import { cubicOut } from "svelte/easing";

import { formatOnlyMonthFull, mod } from "./utils";

export const black = "#2a2a2a";
export const white = "#fff";

// the colorbrewer 9-stop scales in red and blue, except for the lightest steps
export const blues = [
	// :(
	"#deebf7",
	"#c6dbef",
	"#9ecae1",
	"#6baed6",
	"#4292c6",
	"#2171b5",
	"#08519c",
	"#08306b",
];

export const reds = ["#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"];

export const monthNamesShort = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

export const monthNamesFull = [
	"Januar",
	"Februar",
	"März",
	"April",
	"Mai",
	"Juni",
	"Juli",
	"August",
	"September",
	"Oktober",
	"November",
	"Dezember",
];

export const animationParameters = { delay: 0, duration: 400, easing: cubicOut };

export const today = new Date();

const getPreviousMonth = (today) => {
	const currYear = today.getFullYear();
	const currMonth = today.getMonth();
	const targetYear = currMonth === 0 ? currYear - 1 : currYear;
	const targetMonth = mod(currMonth - 1, 12);
	return new Date(targetYear, targetMonth, 1);
};
export const previousMonth = getPreviousMonth(today);

export const daysThresholdForUsingCurrentMonthData = 7;
export const enoughDataForCurrentMonth = today.getDate() > daysThresholdForUsingCurrentMonthData;

export const currentMonth = formatOnlyMonthFull(today);
export const currentMonthIndex = today.getMonth();
export const currentYear = today.getFullYear();
export const lastYear = currentYear - 1;
